/**
 * Hitscan-beam feel — single knob file (constants extraction, 2026-06-12
 * "colors and measurements are configs and named constants, not magic
 * values").
 *
 * Consumed by SwingBeamVFXHandler.onHitscanBeam: a core line plus a wider,
 * dimmer glow line drawn underneath it, both fading out over durationMs.
 * Per-cast event data (color/width/duration) overrides these defaults.
 */
export const HITSCAN_BEAM_CONFIG = {
  /** Default beam color (per-cast `color` overrides win). */
  color: 0xFFFFFF,
  /** Core line width (px). */
  width: 2,
  /** Beam draw lifetime (ms) — both lines fade to 0 over this. */
  durationMs: 200,
  /** Core line alpha at spawn. */
  coreAlpha: 0.9,
  /** Core line render depth. */
  coreDepth: 95,
  /** Glow line width = core width × this. */
  glowWidthMultiplier: 3,
  /** Glow line alpha at spawn (dim halo under the core). */
  glowAlpha: 0.15,
  /** Glow line render depth (under the core). */
  glowDepth: 94,
} as const;
